// // src/hooks/useNavigationBlocker.js
// import { useEffect } from 'react';
// import history from 'src/history';

// export function useNavigationBlocker(blocker, when = true) {
//   useEffect(() => {
//     if (!when) return;

//     const unblock = history.block((tx) => {
//       const retry = () => {
//         unblock();
//         history.push(tx.pathname);
//       };

//       blocker({ location: tx, retry });
//     });

//     // eslint-disable-next-line consistent-return
//     return () => unblock();
//   }, [blocker, when]);
// }

// src/hooks/useNavigationBlocker.js
import { useEffect } from 'react';
import history from 'src/history';

export function useNavigationBlocker(blocker, when = true) {
  useEffect(() => {
    if (!when) return;

    // history.block gives you tx and 'retry' as second arg in v5
    const unblock = history.block((tx, retry) => {
      blocker({ location: tx, retry });
    });

    // eslint-disable-next-line consistent-return
    return () => {
      unblock();
    };
  }, [blocker, when]);
}
